import { billingErrorAccountStatusesSelector } from "./billingErrorAccountStatusesSelector";
import { RootState } from "../../../../store";

export const billingErrorsCountAllProvidersSelector = (
  state: RootState,
): number => {
  const errorAccountStatuses = billingErrorAccountStatusesSelector(state);
  return errorAccountStatuses?.length ?? 0;
};
